import * as yup from 'yup';

const PartsSettingsMappingSchema = yup.object().shape({
    customPartTaxRateEnabled: yup.boolean(),
    customPartTaxRateValue: yup.number().moreThan(-1).max(100),

});

export default PartsSettingsMappingSchema;
